
import TableList from "@components/templates/tablelist";
import {
    HttpGetPurchaseMainList,
    HttpPurchaseMainChangeStatus
} from "@/service/purchase/purchase";
import { mapState, mapGetters } from "vuex";
import comIndex from './update'

export default {
    mixins: [TableList],
    components: {
        comIndex,
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            // Tabs: { show: true },
            // spanTabs: { show: true },
            formData: {
            },
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpGetPurchaseMainList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    {
                        this.operate = {
                            title: '添加',
                            show: true,
                            width: 1200,
                            component: "comIndex",
                            activeid: params,
                            querytype: 'add',
                            showFooter: false
                        }
                    }
                    break;
                case "edit":
                    {
                        this.operate = {
                            title: '编辑',
                            show: true,
                            width: 1200,
                            component: "comIndex",
                            activeid: params,
                            querytype: 'edit',
                            showFooter: false
                        }
                    }
                    break;
                case "query":
                    {
                        this.operate = {
                            title: '查看',
                            show: true,
                            width: 1200,
                            component: "comIndex",
                            activeid: params,
                            querytype: 'query',
                            showFooter: false
                        }
                    }
                    break;
                // case "queryBlank":
                //     {
                //         var url = this.$router.resolve({
                //             name: "purchaseOrderUpdate",
                //             params: { type: "query" },
                //             query: { id: params },
                //         });
                //     }
                //     window.open(url.href, '_blank');
                    break;
                case "active":
                    {
                        this.operate = {
                            show: true,
                            title: "启用",
                            alert: "warning",
                            params: {
                                ids: [params],
                                status: 1
                            },
                            formdata: [
                                {
                                    label: "备注",
                                    key: "remark",
                                    tag: "vTextarea",
                                    required: false,
                                    span: 24
                                }
                            ],
                            ajaxRequest: HttpPurchaseMainChangeStatus,
                        }
                    }
                    break;
                    case "inActive":
                        {
                            this.operate = {
                                show: true,
                                title: "停用",
                                alert: "warning",
                                params: {
                                    ids: [params],
                                    status: 0
                                },
                                formdata: [
                                    {
                                        label: "备注",
                                        key: "remark",
                                        tag: "vTextarea",
                                        required: false,
                                        span: 24
                                    }
                                ],
                                ajaxRequest: HttpPurchaseMainChangeStatus,
                            }
                        }
                        break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row;
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '编辑',
                show: true,
                params: id,
                operate: 'edit'
            }, {
                label: status == 1 ? '停用' : '启用',
                params: id,
                operate: status == 1 ? 'inActive' : 'active',
                show: true
            }]
        },
    },
    computed: {
        getStatus () {
            return [
                {
                    label: "停用",
                    value: 0
                },
                {
                    label: "启用",
                    value: 1
                }
            ]
        },

        SearchsData() {
            return [
                {
                    label: "采购主体（买方）",
                    key: 'CN_name',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "Status",
                    tag: 'vSelect',
                    key: 'IN_status',
                    props: {
                        multiple: true
                    },
                    options: this.getStatus,
                    show: true,
                },
                {
                    label: "备注",
                    tag: "vInput",
                    key: "CN_remark"
                }
            ]
        },
        ToolsData(){
            return [
                {
                    name: "新增",
                    operate: "add",
                    theme: "primary",
                },
            ]
        },
        columns() {
            return [{
                    title: '操作',
                    width: 70,
                    render: this.getOperateNodes,
                }, {
                    title: '采购主体（买方）',
                    width: 200,
                    key: 'name'
                },
                {
                    title: '备注',
                    key: 'remark'
                },
                {
                    title: 'Status',
                    key: "status",
                    render: (h, { row }) => {
                        let statusItem = this.getStatus.filter(item => {
                            return row.status == item.value;
                        })[0];
                        return statusItem.label;
                    }
                },
                {
                    title: 'Creation Date',
                    key: 'createdAt'
                },
                {
                    title: 'Update Date',
                    key: 'updatedAt',
                    minWidth: 100,
                },
            ];
        },

    },

};
